// Status vocabulary for the Refresh Monitor page.
//
// Lives beside the page rather than inside it so the legend test can derive its
// expectations from STATUS_META (exporting these from the .jsx would break Fast
// Refresh, which wants component-only exports).
//
// The API owns the classification; this only maps it to a label, a colour, and
// the definition shown in the page legend.

export const STATUS_META = {
  one_time: { label: "One-time", color: "blue" },
  non_monthly: { label: "Non-monthly", color: "purple" },
  gap: { label: "Gap", color: "error" },
  stale: { label: "Stale", color: "warning" },
  ok: { label: "OK", color: "success" },
};

// Statuses that don't represent a delivery problem, so they're hidden by the
// "Only issues" toggle and excluded from the issue count.
export const NON_ISSUE_STATUSES = new Set(["ok", "one_time", "non_monthly"]);

// Legend rows, rendered one per line under the page description. Order runs most
// to least actionable; `ok` is self-explanatory and left out. Every other key of
// STATUS_META must appear here — the legend test asserts that, so a new status
// can't ship with a tag the page never explains.
export const STATUS_LEGEND = [
  {
    status: "gap",
    description:
      "A month is missing between two present refreshes — likely a deleted or missed refresh, so investigate the DB.",
  },
  {
    status: "stale",
    description: "The latest refresh is behind the expected month.",
  },
  {
    status: "one_time",
    description: "Set up once and not expected to refresh.",
  },
  {
    status: "non_monthly",
    description:
      "Delivers on an irregular cadence, so gaps and staleness aren't flagged.",
  },
];
